Monet.Format = Monet.Format || {};
Monet.Format.DATE_TIME = (function () {
  function DATE_TIME(value) {
    Monet.Format.DATE.apply(this, arguments);
    this.value = value;

    this.toGrid = function () {
      this.value = Monet.Format.DateTime.formatToLocale(this.value);
      return this;
    };
  }

  return DATE_TIME;
})();

Monet.Format.DateTime = {
  // returns a Date object with offset applied
  parse(date, options) {
    return Monet.Format.Date.parse(date, options);
  },

  // parse date and time that were previously formatted to the user's locale
  parseLocale(inputDateTime, options) {
    return Monet.Format.Date.parseLocale(inputDateTime, { ...options, pattern: Monet.I18n.locale.dateTimeFormat });
  },

  // format date and time to user's locale
  formatToLocale(inputDateTime, options) {
    return Monet.Format.Date.formatToLocale(inputDateTime, { ...options, pattern: Monet.I18n.locale.dateTimeFormat });
  },

  parseLocaleToISOString(localeDateString, options) {
    return localeDateString ? 
      this.formatToISOString(this.parseLocale(localeDateString, options)) : '';
  },

  formatToISOString(inputDateTime, options) {
    return Monet.Format.Date.format(
      inputDateTime, 
      { 
        locale: 'en', 
        pattern: 'YYYY-MM-DDTHH:mm:ssZ', 
        ...options 
      }
    );
  },

  getTodayISOString(options) {
    return Monet.Format.Date.format(
      moment()._d, 
      { 
        pattern: 'YYYY-MM-DDTHH:mm:ssZ', 
        ...options 
      }
    );
  },

  getFormattedLocaleToday(options) {
    return (this.formatToLocale(this.getTodayISOString(), options));
  }
};
